import "./Account.module.css";
import Header from "@/reusable_sections/Header";
import MemberDashboard from "./sections/MemberDashboard";
import LatestFromTheJournal from "./sections/LatestFromTheJournal";
import JoinOurEvents from "./sections/JoinOurEvents";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
import Footer from "@/reusable_sections/Footer";
export default function AccountPage() {
  return <div>
      <Header />
      <MemberDashboard />
      <LatestFromTheJournal />
      <JoinOurEvents />
      <GlossyBottomNavigation />
      <Footer />
    </div>;
}